import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BatchManagementService } from '@app/api/stock-service/api/batchManagement.service';
import { BlobConverterUtil } from '@app/shared/utils/blob-converter.util';
import { PermissionService } from '@app/core/services/permission.service';

@Component({
  selector: 'app-fefo-violation',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ButtonModule, InputTextModule, TableModule],
  templateUrl: './fefo-violation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FefoViolationComponent implements OnInit {
  private readonly batches = inject(BatchManagementService);
  private readonly permissionService = inject(PermissionService);
  private readonly cdr = inject(ChangeDetectorRef);

  skuCode = '';
  warehouseId: number | null = null;
  loading = false;
  rows: any[] = [];
  totalElements = 0;
  page = 0;
  size = 20;

  get canView(): boolean {
    return this.permissionService.canDoAction('inventory.fefo_violation.view');
  }

  ngOnInit(): void {
    if (this.canView) {
      this.search();
    }
  }

  search(): void {
    if (!this.canView) {
      return;
    }
    this.loading = true;
    this.batches
      .pageFefoViolations({
        page: this.page,
        size: this.size,
        skuCode: this.skuCode?.trim() || undefined,
        warehouseId: this.warehouseId ?? undefined,
        ascending: false,
        sortBy: 'creationDate',
      })
      .pipe(
        switchMap((response) =>
          BlobConverterUtil.isBlob(response)
            ? BlobConverterUtil.convertToJson(response)
            : of(response),
        ),
      )
      .subscribe({
        next: (result) => {
          this.rows = result?.pageContent ?? result?.content ?? [];
          this.totalElements = result?.totalElements ?? this.rows.length;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.rows = [];
          this.totalElements = 0;
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
